import { Component, ViewEncapsulation } from '@angular/core';
import { EsriLoadService, LoadedModules } from '../shared/esri-load-control.service';
import { BASEMAPS } from './mock-basemap';
import { ControlStatusService } from '../shared/control-status.service';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'rota-basemap',
    templateUrl: './basemap.component.html',
    styleUrls: ['./basemap.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [EsriLoadService]
})
export class BasemapComponent {
  public map: any;
  public view: any;
  public basemapGallery: any;
  constructor(
      private esriLoadService: EsriLoadService,
      public controlStatus: ControlStatusService
    ) { }

  alteraVisibilidade(event){
    $(event.target).parent().toggleClass('open');
  }

  AdicionaMapaGaleria(base: any) {
    var layer = [];
    layer[0] = new LoadedModules.BasemapLayer({
        url: base.url
    });
    if (base.url2 != undefined) {
        layer[1] = new LoadedModules.BasemapLayer({
            url: base.url2,
            isReference: true
        });
    }
    let basemap = new LoadedModules.Basemap({
        layers: layer,
        title: base.titulo,
        thumbnailUrl: base.imagem
    });
    this.basemapGallery.add(basemap);
  }

  AdicionaBaseMapas() {
      for (let i = 0; i < BASEMAPS.length; i++) { this.AdicionaMapaGaleria(BASEMAPS[i]); }
        let openstreetmap = new LoadedModules.Basemap({
          layers: [new LoadedModules.BasemapLayer({
              type: 'OpenStreetMap'
          })],
          id: 'OpenStreetmap',
          title: 'Mapa',
          thumbnailUrl: 'https://www.arcgis.com/sharing/rest/content/items/11e803a6d5f3489698794b027c8133c8/info/thumbnail/temposm.jpg'
      });
      this.basemapGallery.add(openstreetmap);
  }

  iniciaBaseMapaGallery() {
    this.basemapGallery = new LoadedModules.BasemapGallery
    (
        {
          view: this.view,
          visible: true
        },
        
    ); 

    // Add the widget to the top-right corner of the view
    this.map.add(this.basemapGallery, {
      position: "top-right"
    });   
  
    
    // Adiciona um evento de erro
    this.basemapGallery.on('error', function (msg) {
        console.log('Erro ao carregar visão do mapa: ', msg);
    });

    this.basemapGallery.on('selection-change', function () {
        $('#dijit_TitlePane_0_titleBarNode').trigger('click');
    });
  }

  FecharOpcoesMapas() {
      this.controlStatus.mostrarMapas = false;
  }
}
export default BasemapComponent;